import {Component, OnInit} from '@angular/core';
import {StudentCreateRequest, StudentsClient} from '../../../generated-client/generated-api-client';
import {Title} from '@angular/platform-browser';
import {ActivatedRoute, Router} from '@angular/router';
import {FormGroup} from '@angular/forms';
import {ToastrService} from 'ngx-toastr';
import {ErrorProcessorService} from '../../../services/error-processor.service';
import {isFormModifiedDataService} from '../../../services/data-services/navigation-data-services';

@Component({
  selector: 'app-student-new',
  templateUrl: './student-new.component.html',
  styleUrls: ['./student-new.component.sass'],
})
export class StudentNewComponent implements OnInit {
  examReportId!: string;
  studentId!: string;

  constructor(
    private titleService: Title,
    private router: Router,
    private route: ActivatedRoute,
    private client: StudentsClient,
    private toastr: ToastrService,
    private errorProcessorService: ErrorProcessorService,
    private _isFormModifiedDataService: isFormModifiedDataService
  ) {
    route.paramMap.subscribe(next => {
      this.examReportId = next.get('examReportId') ?? '';
    });
    route.paramMap.subscribe(next => {
      this.studentId = next.get('studentId') ?? '';
    });
    this.titleService.setTitle('Vizsgázó létrehozása');
  }

  ngOnInit(): void {}

  onSubmit(form: FormGroup): void {
    const request: StudentCreateRequest = {
      registrationNumber: form.get('registrationNumber')?.value === '' ? null : form.get('registrationNumber')?.value,
      title: form.get('title')?.value === '' ? null : form.get('title')?.value,
      surname: form.get('surname')?.value === '' ? null : form.get('surname')?.value,
      forename1: form.get('forename')?.value === '' ? null : form.get('forename')?.value,
      forename2: form.get('forename2')?.value === '' ? null : form.get('forename2')?.value,
      citizenship: form.get('citizenship')?.value === '' ? null : form.get('citizenship')?.value,
      mothersName: form.get('mothersName')?.value === '' ? null : form.get('mothersName')?.value,
      birthPlace: form.get('birthplace')?.value === '' ? null : form.get('birthplace')?.value,
      birthDate: form.get('birthdate')?.value === '' ? null : form.get('birthdate')?.value,
      birthName: form.get('birthName')?.value === '' ? null : form.get('birthName')?.value,
      email: form.get('email')?.value === '' ? null : form.get('email')?.value,
      language: form.get('language')?.value === '' ? null : form.get('language')?.value,
      computerNumber: form.get('computerNumber')?.value === '' ? null : form.get('computerNumber')?.value,
      examStartedAtUtc: form.get('examStartedAtUtc')?.value === '' ? null : form.get('examStartedAtUtc')?.value,
      examReportId: this.examReportId,
    };

    this.client.create(request).subscribe(
      next => {
        this.toastr.success('Sikeres vizsgázó hozzárendelés');
        this._isFormModifiedDataService.isFormModified = false;
        this.router.navigate([`/exam-reports/${this.examReportId}/students/${next.entityId}`]);
      },
      error => this.errorProcessorService.processError(error, true)
    );
  }
}
